import React from "react";
import SignInForm from "./LeftPannel";
import InfoPanel from "../components/RightPannel";
const login = () => {
  return (
    <InfoPanel parent="signup">
      <SignInForm />
    </InfoPanel>
  );
};

export default login;
